import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogState } from '../../data-model/dialog-state';
import { EnvironmentService } from '../../services/environment.service';
import { UserProductService } from '../../services/user/user-product.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'bell-modal-dialog',
    template: '',
    styleUrls: ['./modal-dialog.component.scss'],
    standalone: false
})
export class ModalDialogComponent implements OnInit, OnDestroy, AfterViewInit {
  show = { 'display' : 'none'};
  thanks = { 'display' : 'none'};
  public returnHREF = '';
  public salesForceEnvironment: {url: string, orgId: string, reportDeficiencyRecordType: string, aogId: string};
  public email = '';
  dialogState = DialogState;
  successParam = 'success';

  subscriptions: Subscription[] = [];

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected env: EnvironmentService,
    protected userProduct: UserProductService
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.router.events.subscribe(() => this.changeReturnHREF()));
    this.changeReturnHREF();
    this.salesForceEnvironment = this.env.getSalesForceW2C();
    this.getEmail();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => {
      if (s) {
        s.unsubscribe();
      }
    });
  }

  ngAfterViewInit() {
    this.subscriptions.push(this.route.queryParams.subscribe(param => {
      if (param[this.successParam]) {
        this.setDialogState(DialogState.result);
      }
    }));
  }

  getEmail() {
    this.userProduct.getUserProduct()
    .subscribe((up) => {
      this.email = up ? up.email : undefined;
    });
  }

  public changeReturnHREF() {
    this.returnHREF = window.location.href + '?' + this.successParam + '=true';
  }

  public setDialogState(newState: DialogState) {
    switch (newState) {
      case DialogState.form: {
        this.show = { 'display' : 'block'};
        this.thanks = { 'display' : 'none'};
        break;
      }
      case DialogState.result: {
        this.show = { 'display' : 'none'};
        this.thanks = { 'display': 'block'};
        break;
      }
      default: {
        this.thanks = { 'display' : 'none'};
        this.show = { 'display' : 'none'};
        break;
      }
    }
  }
}
